import React, { useEffect, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Polyline, useMap, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import Auto from '../../assets/images/dashboard/locationPin.png';

function TripsMap({route}) {
    console.log("Trips Map", route);

    const customIcon = L.icon({
        iconUrl: Auto, // Path to the auto icon image
        iconSize: [30, 30], // Size of the icon
        iconAnchor: [15, 30], // Anchor point of the icon (middle bottom)
    });

    // const coordinates = props.tripDetails.cabRequestDetails[0].coordinates.map(coord => [coord.latitude, coord.longitude]);
    // const { cabRequestDetails } = props.tripDetails;
    // const pickupLocation = cabRequestDetails[0].pickup_location;
    // const dropLocation = cabRequestDetails[0].drop_location;

    // Custom hook to zoom the map to fit all the coordinates
    // function ZoomToBounds() {
    //     const map = useMap();
    //     useEffect(() => {
    //         if (coordinates.length > 0) {
    //             const bounds = L.latLngBounds(coordinates);
    //             map.fitBounds(bounds, {
    //                 padding: [50, 50], // Padding around the bounds
    //                 maxZoom: 15, // Maximum zoom level to fit bounds
    //             });
    //         }
    //     }, [map, coordinates]);

    //     return null;
    // }

    // Generate a unique key for the MapContainer to force re-render on coordinates change
    // const mapKey = useMemo(() => JSON.stringify(coordinates), [coordinates]);

    return (
        <MapContainer
        center={[15.2689, 76.3909]}
        zoom={5}
        style={{ height: '500px', width: '100%' }}
        scrollWheelZoom={false}
    >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            {/* Custom hook to zoom the map */}
            {route.map((trip, index) => (
                <React.Fragment key={index}>
                    {/* Render the polyline for the trip's path */}
                    <Polyline positions={trip.relatedCabRequests[0].coordinates.map(coord => [coord.latitude, coord.longitude])} color="blue" />

                    {/* Render marker for pickup location */}
                    <Marker position={[trip.relatedCabRequests[0].pickup_location.latitude, trip.relatedCabRequests[0].pickup_location.longitude]} icon={customIcon}>
                        {/* <Tooltip permanent>{trip.relatedCabRequests[0].pickup_location.title}</Tooltip> */}
                    </Marker>

                    {/* Render marker for drop location */}
                    <Marker position={[trip.relatedCabRequests[0].drop_location.latitude, trip.relatedCabRequests[0].drop_location.longitude]} icon={customIcon}>
                        {/* <Tooltip permanent>{trip.relatedCabRequests[0].drop_location.title}</Tooltip> */}
                    </Marker>
                </React.Fragment>
            ))}
        </MapContainer>
    
    );
}

export default TripsMap;
